import React from 'react';
import PropType from 'prop-types';

// FontAwesome
import { faPaw } from '@fortawesome/free-solid-svg-icons';

// Atoms
import {
	Cell, Icon, Cross, CrossBarLeft, CrossBarRight, ActiveCell,
} from './Table.atoms';
import { columnNames } from '../../../lib/constants/table';
import { GameSettingsContext } from '../../Context/GameSettingsManager';

const TableCell = ({
	column, cell, onClick, announce, cancelAnnouncement, rollsLeft, opponentTable, command, columnId,
}) => {
	const { hideFieldHighlighting } = React.useContext(GameSettingsContext);
	let cellContent = null;

	const canDisableAnnounce = announce.cell?.name === cell.name && announce?.column?.name === column?.name && rollsLeft === 2;
	// 1.If cell is active and hihglighting is enabled 2.if opponent have announce a move 3. opponent announced cell
	if ((cell.isActive && !hideFieldHighlighting)
		|| (command.cell?.name === cell.name && columnNames.COMMAND === column.name)
		|| (opponentTable && announce.cell?.name === cell.name && columnNames.ANNOUNCE === column.name)
	) {
		cellContent = (
			<ActiveCell active={cell.isActive}>
				<Icon icon={faPaw} cross={cell.currentValue === 0 ? 1 : 0} />
			</ActiveCell>
		);
		// Announce field
	} else if (canDisableAnnounce) {
		cellContent = (
			<ActiveCell active={cell.isActive}>
				<Icon icon={faPaw} cross={cell.currentValue === 0 ? 1 : 0} />
			</ActiveCell>
		);
	} else {
		cellContent = cell.value === 0 ? 'x' : cell.value;
	}
	// Classes are defined in CellsWrapper
	const classes = [];
	if (cell.background) {
		classes.push('cell-background');
	}
	if (cell.value === 0) {
		classes.push('cell-bold');
	}
	return (
		<Cell
			onClick={() => onClick(column, cell, columnId)}
			key={`${column.id} ${cell.name}`}
			className={classes}
		>
			{canDisableAnnounce && (
				<Cross onClick={(e) => {
					e.stopPropagation();
					cancelAnnouncement();
				}}
				>
					<CrossBarLeft />
					<CrossBarRight />
				</Cross>
			)}
			{cellContent}
		</Cell>
	);
};
TableCell.defaultProps = {
	opponentTable: false,
};
TableCell.propTypes = {
	columnId: PropType.string.isRequired,
	rollsLeft: PropType.number.isRequired,
	cancelAnnouncement: PropType.func.isRequired,
	announce: PropType.shape({
		cell: PropType.shape({
			name: PropType.string,
		}),
		column: PropType.shape({}),
	}).isRequired,
	command: PropType.shape({
		cell: PropType.shape({
			name: PropType.string,
		}),
	}).isRequired,
	onClick: PropType.func.isRequired,
	column: PropType.shape({
		name: PropType.string,
		id: PropType.string,
	}).isRequired,
	cell: PropType.shape({
		background: PropType.bool,
		name: PropType.string,
		value: PropType.number,
		isActive: PropType.bool,
		currentValue: PropType.number,
	}).isRequired,
	opponentTable: PropType.bool,
};

export default TableCell;
